import {Component} from "@angular/core";
import {NavigationService} from "../../orchestration/navigation.service";
import {SessionModel} from "../../orchestration/session.model";
import {FedeltaImageData} from "@fedelta-pos/data-client";
import {AnalyticsService} from "../../orchestration/analytics.service";
import {ButtonConnotation, ButtonProminence} from "../../buttons/button/button";
import {Page} from "../../orchestration/page";
import {MenuModel} from "../../menu/menu.model";
import {NavigationParams} from "../../orchestration/navigation-params";
import {AppPromoAction, AppPromoData} from "../../identity/member-summary-entity.model";
import {MenuItemData} from "../../menu/menu-entity.model";

@Component({
    selector: "woa-promo-page",
    templateUrl: "./promo-page.component.html",
    providers: [{provide: Page, useExisting: PromoPageComponent}]
})
export class PromoPageComponent extends Page {
    ButtonConnotation = ButtonConnotation;
    ButtonProminence = ButtonProminence;

    title: string;
    image: string | FedeltaImageData;
    autoCropImage: boolean;
    promo: AppPromoData;
    menuItem: MenuItemData;

    constructor(navigationParams: NavigationParams,
                private analyticsService: AnalyticsService,
                public navigationService: NavigationService,
                public menuModel: MenuModel,
                public sessionModel: SessionModel) {
        super();
        this.promo = navigationParams.get("promo");
        this.menuItem = navigationParams.get("menuItem");

        this.title = this.promo.appText1 ? "woa.heading.promo.appText"
            : this.menuItem ? "woa.heading.promo.default"
                : "woa.heading.promo.name";
        ({image: this.image, autoCropImage: this.autoCropImage} = this.getImage());

        // noinspection JSIgnoredPromiseFromCall
        this.analyticsService.trackPromoShown(this.promo ? this.promo.name : undefined, "popup",
            this.menuItem ? this.menuItem.name : undefined, this.menuItem ? this.menuItem.sellable.defaultPrice : undefined, this.menuItem ? this.menuItem.sellable.plu : undefined);
    }

    private getImage(): {image: string | FedeltaImageData, autoCropImage: boolean} {
        if (this.promo.image.id) {
            return {image: this.promo.image, autoCropImage: this.promo.imageAutoCrop};
        }
        if (this.menuItem) {
            const image: FedeltaImageData = this.menuModel.getItemImage(undefined, this.menuItem, true);
            if (image) {
                return {image: image, autoCropImage: this.promo.imageAutoCrop};
            }
        }
        if (this.sessionModel.currentApp.defaultImage) {
            return {image: "data:image;base64," + this.sessionModel.currentApp.defaultImage, autoCropImage: false};
        }
        return {image: undefined, autoCropImage: false};
    }

    get imageData(): FedeltaImageData {
        return <FedeltaImageData> this.image;
    }

    get hasAction(): boolean {
        return this.menuItem && !!this.promo.popupAction;
    }

    onDidDismissPage(actioned: boolean): void {
        if (this.hasAction && !actioned) {
            // noinspection JSIgnoredPromiseFromCall
            this.analyticsService.trackPromoCancelled(this.promo ? this.promo.name : undefined, "popup",
                this.menuItem ? this.menuItem.name : undefined, this.menuItem ? this.menuItem.sellable.defaultPrice : undefined, this.menuItem ? this.menuItem.sellable.plu : undefined);
        }
    }

    async performAction(onlyWhenNoButton: boolean = false): Promise<any> {
        if (this.promo && !this.promo.popupAction) {
            return;
        }
        if (onlyWhenNoButton && this.promo && this.promo.showActionButtonOnPopup) {
            return;
        }
        if (this.promo) {
            switch (this.promo.popupAction) {
                case AppPromoAction.ORDER_PRODUCT:
                    // noinspection ES6MissingAwait
                    this.analyticsService.trackPromoItemOrdered(this.promo.name, "popup",
                        this.menuItem ? this.menuItem.name : undefined, this.menuItem ? this.menuItem.sellable.defaultPrice : undefined, this.menuItem ? this.menuItem.sellable.plu : undefined);
                    break;
                case AppPromoAction.SHOW_PRODUCTS:
                    // noinspection ES6MissingAwait
                    this.analyticsService.trackPromoItemsShown(this.promo.name, "popup");
                    break;
            }
        } else {
            // noinspection ES6MissingAwait
            this.analyticsService.trackPromoItemOrdered(undefined, "popup",
                this.menuItem ? this.menuItem.name : undefined, this.menuItem ? this.menuItem.sellable.defaultPrice : undefined, this.menuItem ? this.menuItem.sellable.plu : undefined);
        }
        return this.navigationService.dismissPage(this, true);
    }
}



// WEBPACK FOOTER //
// ./src/app/promo/promo-page/promo-page.component.ts